import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelText as _vModelText } from "vue"
import _imports_0 from '@/assets/loading.svg'
import _imports_1 from '@/assets/check.svg'
import _imports_2 from '@/assets/cross.svg'
import _imports_3 from '@/assets/orange-dot.svg'


const _hoisted_1 = { class: "title-1" }
const _hoisted_2 = { class: "dashboard" }
const _hoisted_3 = { class: "widget widget-number" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Recherches effectuées cette saison ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Recherche effectuée cette saison")
const _hoisted_6 = { class: "big-number" }
const _hoisted_7 = {
  key: 1,
  class: "spinner"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "spinner-icon",
  alt: "UNUCR"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "widget" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-1 title-5" }, "Gibiers", -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "spinner"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "spinner-icon",
  alt: "UNUCR"
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "widget widget-list" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h2", null, "Fiches récentes", -1)
const _hoisted_18 = { class: "list-container" }
const _hoisted_19 = { class: "list__items" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 0,
  class: "icon",
  src: _imports_1,
  alt: ""
}
const _hoisted_23 = {
  key: 1,
  class: "icon",
  src: _imports_2,
  alt: ""
}
const _hoisted_24 = {
  key: 2,
  class: "icon",
  src: _imports_3,
  alt: ""
}
const _hoisted_25 = {
  key: 1,
  class: "spinner"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "spinner-icon",
  alt: "UNUCR"
}, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { class: "widget widget-actions" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Saisir une fiche")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Voir mes fiches")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Modifier mon profil")
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Déclarer un état négatif ")
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h2", { class: "title-3" }, "Déclarer un état négatif", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", null, " Attention, valider un \"état négatif\" signifie que vous n'avez effectué aucune intervention cette saison. Vous ne pourrez plus saisir de fiche cette saison. ", -1)
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Saison: ")
const _hoisted_39 = ["value"]
const _hoisted_40 = ["value"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h2", { class: "title-3" }, " Déclarer la puissance fiscale de votre véhicule ", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", null, " Pour être en adéquation avec la réglementation, chaque fiche bénéficiant de la déduction kilométrique doit maintenant renseigner la puissance fiscale du véhicule utilisé. Pour rendre conforme vos fiches déjà saisies, merci de bien vouloir renseigner la puissance fiscale de votre véhicule. ", -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Puissance fiscale de votre véhicule: ")

import { useUser } from "@/domains/auth/user";
import { Game } from "@/domains/cruds/games/games";
import { FAILURE_IDS, SUCCESSFUL_IDS } from "@/domains/cruds/results/results";
import { getSheetsRecap, Sheet } from "@/domains/cruds/sheets/sheets";
import { Ref, ref } from "@vue/reactivity";
import { computed, watch } from "@vue/runtime-core";
import { useMetaTitle } from "../pageMeta";
import { useResourcesState } from "../resource";
import router from "../router/router";
import Modal from "../components/Modal.vue";
import { request } from "@/domains/api/api";
import { useLoading } from "../loading";
import { AxiosError } from "axios";
import { getMessage } from "../translation";
import { useFlashes } from "@/domains/flashes/flashes";
import { getSeasonBound } from "@/domains/statistics/tools";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const sheets: Ref<Sheet[] | null> = ref(null);
const totalSheets: Ref<number> = ref(0);
const negativeState = ref(false);

const error: Ref<string> = ref("");

const showNegativeStateModal = ref(false);
const showUpdateVehiculePowerModal = ref(false);

const updateVehiculePowerPayload = ref(0);

const user = useUser().user;

const currentSeason = getSeasonBound(new Date().getTime());
const prevSeason = getSeasonBound(
    new Date().getTime() - 1000 * 60 * 60 * 24 * 365
);
const negativeStateSeason = ref(currentSeason.start);

useMetaTitle().setTitle("Dashboard");

watch(
    user,
    (value) => {
        if (!value) return;
        const gamesRecapPromise = getSheetsRecap((err) => {
            error.value = err.message
                ? err.message
                : "Impossible de récupérer les fiches";
        }).then((data) => {
            sheets.value = data["recent-sheets"];
            totalSheets.value = data.total;
            negativeState.value = data.negativeState;
            if (data["has-paid-trips-without-vehicule-power"]) {
                showUpdateVehiculePowerModal.value = true;
            }
            return data.games;
        });

        let resolveGames: any;
        const gamesPromise = new Promise<void>((res) => (resolveGames = res));
        const games = useResourcesState<Game>("games").data;
        const unwatchGames = watch(games, () => {
            if (resolveGames) resolveGames();
            unwatchGames();
        });

        Promise.all([gamesRecapPromise, gamesPromise]).then(([gamesRecap]) => {
            gamesPreview.value = games.value.map((g) => ({
                count: gamesRecap.find((game) => game.id === g.id)?.count || 0,
                label: g.label,
                id: g.id,
            }));
        });
    },
    { immediate: true }
);

const successfulSheets = computed<null | Sheet[]>(() => {
    if (sheets.value === null) return null;
    return sheets.value.filter((s) => SUCCESSFUL_IDS.includes(s.result_id));
});

const failureSheets = computed<null | Sheet[]>(() => {
    if (sheets.value === null) return null;
    return sheets.value.filter((s) => FAILURE_IDS.includes(s.result_id));
});

const gamesPreview = ref<{ label: string; count: number; id: number }[]>();

const pageTitle = computed<string>(() => {
    if (user.value) {
        const firstName = user.value.first_name
            ? user.value.first_name.charAt(0).toUpperCase() +
              user.value.first_name.substring(1)
            : null;
        const lastName = user.value.last_name
            ? user.value.last_name.charAt(0).toUpperCase() +
              user.value.last_name.substring(1)
            : null;
        if ((firstName == lastName) == null) {
            return "Profil";
        }
        return (
            (firstName ? firstName + " " : "") +
            (lastName ? lastName + " " : "") +
            (user.value.member_num ? `(${user.value.member_num})` : "")
        );
    }
    return "Récupération du profil ...";
});

function goToSheet(id: number) {
    router.push({ name: "sheets.edit", params: { id } });
}

function parseDate(date: Date | number | string) {
    const formatted = new Date(date);
    const day = formatted.getDate().toString().padStart(2, "0");
    const month = (formatted.getMonth() + 1).toString().padStart(2, "0");
    const year = formatted.getFullYear().toString().padStart(2, "0");
    return `${day}/${month}/${year}`;
}

function updateVehiculePower() {
    if (updateVehiculePowerPayload.value <= 0) {
        const { addFlash } = useFlashes();
        addFlash(
            "La puissance fiscale de votre véhicule doit être supérieure à 0",
            "error",
            5000
        );
        return;
    }
    const { setLoading } = useLoading("update-sheets-vehicule-power");
    showUpdateVehiculePowerModal.value = false;
    request(
        "sheets/fix_paid_trips_vehicule_power",
        "post",
        () => {
            null;
        },
        { vehicule_power: updateVehiculePowerPayload.value }
    )
        .then(() => {
            const { addFlash } = useFlashes();
            addFlash(
                "La puissance fiscale de vos fiches a été mise à jour",
                "success",
                5000
            );
        })
        .catch((e: AxiosError<{ message: string }>) => {
            const errorKey = e.response?.data?.message;
            const errText = errorKey
                ? getMessage(errorKey)
                : "Une erreur est survenue";
            const { addFlash } = useFlashes();
            addFlash(errText, "error", 5000);
        })
        .finally(() => setLoading(false));
}

function declareNegativeState() {
    const { setLoading } = useLoading("declare-negative-state");
    showNegativeStateModal.value = false;
    const shouldSetNegativeState =
        currentSeason.start === negativeStateSeason.value;
    request(
        "negative-states",
        "post",
        () => {
            null;
        },
        { season_start: negativeStateSeason.value }
    )
        .then(() => {
            negativeState.value = shouldSetNegativeState;
        })
        .catch((e: AxiosError<{ message: string }>) => {
            const errorKey = e.response?.data?.message;
            const errText = errorKey
                ? getMessage(errorKey)
                : "Une erreur est survenue";
            const { addFlash } = useFlashes();
            addFlash(errText, "error", 5000);
        })
        .finally(() => setLoading(false));
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading_key = _resolveDirective("loading-key")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(pageTitle)), 1),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("article", _hoisted_3, [
        _createElementVNode("h2", null, [
          (totalSheets.value != 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_4
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_5
              ], 64))
        ]),
        _createElementVNode("span", _hoisted_6, [
          (sheets.value !== null)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(totalSheets.value), 1)
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
        ])
      ]),
      _createElementVNode("article", _hoisted_10, [
        _hoisted_11,
        (gamesPreview.value !== undefined)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gamesPreview.value, (game) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: game.id
                }, _toDisplayString(game.label) + " : " + _toDisplayString(game.count), 1))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
      ]),
      _createElementVNode("article", _hoisted_16, [
        (sheets.value?.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_17,
              _createElementVNode("table", _hoisted_18, [
                _createElementVNode("tbody", _hoisted_19, [
                  (sheets.value !== null)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(sheets.value, (sheet, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          class: "list-item",
                          key: index,
                          onClick: ($event: any) => (goToSheet(sheet.id))
                        }, [
                          _createElementVNode("td", null, _toDisplayString(parseDate(sheet.date)), 1),
                          (sheet.game)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(sheet.game.label), 1))
                            : _createCommentVNode("", true),
                          (
                                        _unref(successfulSheets) !== null &&
                                        _unref(failureSheets) !== null
                                    )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (_unref(successfulSheets).includes(sheet))
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_22))
                                  : (
                                            _unref(failureSheets).includes(sheet)
                                        )
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_23))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_24))
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_20))
                      }), 128))
                    : (_openBlock(), _createElementBlock("tr", _hoisted_25, _hoisted_27))
                ])
              ])
            ], 64))
          : (negativeState.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_28, " Vous avez déclaré un avis négatif pour cette saison. "))
            : (_openBlock(), _createElementBlock("p", _hoisted_29, "Aucune fiche récente"))
      ]),
      _createElementVNode("article", _hoisted_30, [
        (!negativeState.value)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "btn btn-primary",
              to: { name: 'sheets.create' }
            }, {
              default: _withCtx(() => [
                _hoisted_31
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          class: "btn btn-secondary",
          to: { name: 'sheets.index' }
        }, {
          default: _withCtx(() => [
            _hoisted_32
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          class: "btn btn-secondary",
          to: { name: 'profile.edit' }
        }, {
          default: _withCtx(() => [
            _hoisted_33
          ]),
          _: 1
        }, 8, ["to"]),
        (!negativeState.value && sheets.value !== null)
          ? _withDirectives((_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-secondary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showNegativeStateModal.value = true))
            }, _hoisted_35)), [
              [_directive_loading_key, 'declare-negative-state']
            ])
          : _createCommentVNode("", true),
        (showNegativeStateModal.value)
          ? (_openBlock(), _createBlock(Modal, {
              key: 2,
              onConfirm: declareNegativeState,
              onCancel: _cache[2] || (_cache[2] = ($event: any) => (showNegativeStateModal.value = false))
            }, {
              default: _withCtx(() => [
                _hoisted_36,
                _hoisted_37,
                _createElementVNode("label", null, [
                  _hoisted_38,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((negativeStateSeason).value = $event))
                  }, [
                    _createElementVNode("option", {
                      value: _unref(currentSeason).start
                    }, _toDisplayString(_unref(currentSeason).label), 9, _hoisted_39),
                    _createElementVNode("option", {
                      value: _unref(prevSeason).start
                    }, _toDisplayString(_unref(prevSeason).label), 9, _hoisted_40)
                  ], 512), [
                    [_vModelSelect, negativeStateSeason.value]
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (showUpdateVehiculePowerModal.value)
          ? (_openBlock(), _createBlock(Modal, {
              key: 3,
              onConfirm: updateVehiculePower,
              onCancel: _cache[4] || (_cache[4] = ($event: any) => (showUpdateVehiculePowerModal.value = false))
            }, {
              default: _withCtx(() => [
                _hoisted_41,
                _hoisted_42,
                _createElementVNode("label", null, [
                  _hoisted_43,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    min: "1",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((updateVehiculePowerPayload).value = $event)),
                    style: {"background-color":"white"}
                  }, null, 512), [
                    [_vModelText, updateVehiculePowerPayload.value]
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})